export const sizes = {
   Medium: {
      padding: 'p-16px',
      borderRadius: 'rounded-12px',
      marginRight: 'mr-12px',
      radioLabelMargin: 'mb-12px',
      icon: {
         height: 20,
         width: 20
      }
   },
   Small: {
      padding: 'p-16px',
      borderRadius: 'rounded-12px',
      marginRight: 'mr-8px',
      radioLabelMargin: 'mb-8px',
      icon: {
         height: 16,
         width: 16
      }
   }
}
